<template>
  <!-- Add class for avatar size, default medium -->
  <div class="ut-flex" v-bind:class="[`avatar-${size}`]">
    <div class="ut-circle-img avatar-img">
      <img v-if="cdnAgentAvatar" :src="cdnAgentAvatar">
    </div>
    <div class="avatar-info" v-if="this.$slots.name || this.$slots.label">
      <div v-if="this.$slots.name" class="avatar-name"><slot name="name"></slot></div>
      <div v-if="this.$slots.label" class="avatar-label"><slot name="label"></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    imgSrc: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: 'md',
    },
  },
  computed: {
    cdnAgentAvatar() {
      return this.$helpers.getCdnAgentAvatar(this.imgSrc);
    },
  },
};
</script>

<style scoped lang="scss">
  .avatar-img {
    @apply ut-mx-0;
      height: 50px;
      width: 50px;
    }

  .avatar-info {
    @apply ut-ml-2;

    .avatar-name {
      @apply ut-mb-1;
      color: #00393E;
      font-size: 16px;
      line-height: 20px;
      font-weight: 700;

    }

    .avatar-label {
      color: #00393E;
      font-size: 14px;
      line-height: 18px;
    }

  }

  .avatar-sm {
    .avatar-img {
      height: 34px;
      width: 34px;
    }

    .avatar-info {
      @apply ut-ml-2;

      .avatar-name {
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;

      }

      .avatar-label {
        display: none;
      }

    }
  }
</style>
